import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { FormattedHTMLMessage } from 'sb-react-intl'
import { links, constants, array, getMergedProductAndVolume, formatPrice } from 'common/helpers'

import { Grid } from 'components/_new/layout'
import Modal from 'components/modal/Modal/Modal'
import { Button, buttonMessages, AddToQueueOrCartButton } from 'components/_new/controls'

import messages from './messages'
import s from './MembershipInfoModal.scss'

import step1 from './images/step1.svg'
import step2 from './images/step2.svg'
import step3 from './images/step3.svg'


const steps = [
  step1,
  step2,
  step3,
]

class MembershipInfoModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: constants.modals.MembershipInfo,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const {
      name, data: { id, img, brand, activeVolume, metadata, snowplowMetadata },
      isSubscribed, subscriptionPrice,
    } = this.props

    const addTo       = activeVolume ? (activeVolume.type === 'subscription' ? 'queue' : 'cart') : false
    const product     = { id, name, brand, img }
    const productInfo = getMergedProductAndVolume(product, activeVolume)
    const isAddToQueueButtonDisabled = activeVolume ? !activeVolume.inStock : true

    return (
      <Modal
        className={s.membershipInfoModal}
        name={name}
        onClose={this.close}
      >
        <Grid
          className={s.steps}
          columns={{
            mobile: 1,
            tabletPortrait: 1,
            tabletLandscape: 3,
            desktop: 3,
          }}
        >
          {
            array.range(1, 3).map((count, index) => {
              const { title, description } = messages[count]

              return (
                <Grid.Cell key={count} className={s.step} size={1}>
                  <div className={s.row}>
                    <div className={s.number}>{count}</div>
                    <FormattedHTMLMessage className={s.title} {...title} values={{ subscriptionPrice }} />
                  </div>
                  <FormattedHTMLMessage tag="div" className={s.description} {...description} />
                  <img className={s.image} src={steps[index]} alt="Scentbird membership" />
                </Grid.Cell>
              )
            })
          }
        </Grid>
        <div className={s.buttons}>
          {
            addTo ? (
              <AddToQueueOrCartButton
                className={s.button}
                disabled={isAddToQueueButtonDisabled}
                product={productInfo}
                title={isSubscribed ? null : buttonMessages.subscribeNow}
                onAfterAdd={this.close}
                addTo={addTo}
                metadata={metadata}
                snowplowMetadata={snowplowMetadata}
                color="brand"
                size="md"
                dataTestId={constants.testIds.payment.addProductButton}
              />
            ) : (
              <Button
                className={s.button}
                title={buttonMessages.subscribeNow}
                to={links.register}
                color="brand"
                size="md"
                dataTestId={constants.testIds.payment.addProductButton}
                onClick={this.close}
              />
            )
          }
          <Button
            className={cx(s.button, s.backButton)}
            title={buttonMessages.back}
            color="transparent"
            size="md"
            dataTestId="backButton"
            onClick={this.close}
          />
        </div>
      </Modal>
    )
  }
}


export default connect({
  isSubscribed: 'models.subscription.isSubscribed',
  subscriptionPrice: (state) => formatPrice(state.models.subscription.price, true),
})(MembershipInfoModal)
